import { useState, useEffect } from 'react';

// Live weather in Abidjan (Open-Meteo — free, no API key).
// When it actually rains there, the portfolio's rain turns on by itself.
// Any failure (offline, ad-blocker, API down) silently resolves to null.

const API =
  'https://api.open-meteo.com/v1/forecast?latitude=5.36&longitude=-4.0083&current=rain,precipitation,weather_code';

// WMO codes: drizzle, rain, showers, thunderstorms
const RAIN_CODES  = new Set([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82, 95, 96, 99]);
const HEAVY_CODES = new Set([63, 65, 67, 81, 82, 95, 96, 99]);

const CACHE_KEY = 'abj-weather';
const CACHE_TTL = 20 * 60 * 1000; // 20 min

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { t, data } = JSON.parse(raw);
    if (Date.now() - t > CACHE_TTL) return null;
    return data;
  } catch {
    return null;
  }
}

function writeCache(data) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data }));
  } catch {}
}

export function useLiveWeather() {
  const [weather, setWeather] = useState(readCache);

  useEffect(() => {
    if (weather) return;
    if (typeof fetch === 'undefined') return;
    let cancelled = false;

    fetch(API)
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => {
        if (cancelled || !json?.current) return;
        const code = json.current.weather_code;
        const raining =
          RAIN_CODES.has(code) ||
          (json.current.rain ?? 0) > 0 ||
          (json.current.precipitation ?? 0) > 0.05;
        const data = { raining, heavy: HEAVY_CODES.has(code) };
        writeCache(data);
        setWeather(data);
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, [weather]);

  return weather;
}
